import { useEffect, useRef, useState } from "react";
import $ from 'jquery';
import Inff001 from '../inf/Inff001';
import { observer } from "mobx-react";
import { Provider } from "react-redux";
import store from "../../store";
import rootScope from "../../store/rootScopeStore";
import useIsMobile from "../../util/useIsMobile";
const DialogBase = observer((props) => {
    let isMobile = useIsMobile();
    let optionsConfig = {
        component: "",
        title: "",
        size: "",
        params: {},
        parentScope: {},
        parentAttr: {}
    };
    let footerOptionsConfig = {
        detailBtn: null,
        clearBtn: null,
        commitBtn: null,
        endBtnFunc: null,
    }
    //TODO
    let isErrMsgDisp = false;
    const modalDialog = useRef(null);
    const [options, setOptions] = useState(optionsConfig);
    const [footerOptions, setFooterOptions] = useState(footerOptionsConfig);
    useEffect(() => {
        if (props.options) {
            setOptions(props.options);
            if (props.options.footerOptions) setFooterOptions(props.options.footerOptions);
            let dialogcontailer = null;
            const dialogcontailers = document.querySelectorAll('.dialog-base-contailer');
            const navbar = document.querySelector('.navbar');
            const modalDialogEle = $(modalDialog.current);
            for (let index = Object.keys(dialogcontailers).length - 1; index >= Object.keys(dialogcontailers).length - 1; index--) {
                if (!dialogcontailers[index].style.zIndex) {
                    dialogcontailer = dialogcontailers[index];
                }
            }
            let topDefault = -(dialogcontailer.offsetTop + modalDialogEle[0].offsetHeight + navbar.offsetHeight + 100);
            let top = 30;
            const root = $('#root');
            document.body.classList.add('modal-open');
            root.addClass('modal-open');
            let dialog = modalDialogEle;
            if (!props.options.backdrop) {
                dialog = $(dialogcontailer);
                dialog.addClass(props.options.size ? `modal-${props.options.size}` : '');
                topDefault = - (window.outerHeight);
                top = - (dialogcontailer.offsetTop - 100);
                dialog.css({
                    margin: 'auto'
                })
                modalDialogEle.css({
                    margin: '0'
                });
            }
            dialog.css({
                top: `${topDefault}px`
            });
            setTimeout(() => {
                dialog.animate({
                    top: `${top}px`
                }, {
                    duration: 500
                });
                modalDialogEle.css({
                    display: 'block'
                });
                if (!props.options.draggable) {
                    dialog.draggable({ disabled: true });
                } else {
                    dialog.draggable();
                }
            }, 0);
            let zIndex = 100;
            if (rootScope.modalScopes && rootScope.modalScopes.length) {
                zIndex = rootScope.modalScopes[rootScope.modalScopes.length - 1].zIndex + 10;
            }
            dialogcontailer.style.zIndex = zIndex;

            const option = {
                detailBtn: footerOptions.detailBtn,
                clearBtn: footerOptions.clearBtn,
                commitBtn: footerOptions.commitBtn,
                endBtnFunc: footerOptions.endBtnFunc,
                footer: {
                    endBtn: {
                        'func': closedProc,
                    }
                },
                zIndex: zIndex,
                model: 'dialog-base-contailer'
            }
            rootScope.modalScopes.push(option);
        }
    }, [props.options]);

    /**
     * モーダルの結果取得
     * 
     * @param {any} result 
     */
    const modalInstanceResult = (result) => {
        // 検索ボタンで照会画面を起動した場合、テキストボックスにフォーカスをあてる
        closedProc();
        if (props.resultFunc) {
            props.resultFunc(result);
        }
    }

    /**
     * 
     * 
     * @param {any} flag 
     */
    const setIsErrMsgDisp = (flag) => {
        isErrMsgDisp = flag;
    }

    /**
     * 
     * 
     * @returns 
     */
    const screenDailog = () => {

        let screen = '';
        switch (options.component) {
            case 'Inff001':
                screen = (<Inff001 close={modalInstanceResult} params={options.params}></Inff001>);
                break;
            case 'Inff001':
                screen = (<Inff001 close={modalInstanceResult}></Inff001>);
                break;
            default:
                screen = '';
                break;
        }
        return screen;
    }

    /**
     * 画面を閉じた後の処理
     * 
     */
    const closedProc = () => {
        const containers = document.querySelectorAll('.dialog-base-contailer');
        if (containers && containers.length) {
            containers[containers.length - 1].remove();
            if (containers.length == 1) {
                document.body.classList.remove('modal-open');
                document.body.querySelector('#root').classList.remove('modal-open');
            }
            rootScope.modalScopes.pop();
        }
    }
    return (
        <Provider store={store}><> <div ref={modalDialog} className={`modal-box modal-dialog modal-content ${props.className} ${options.size ? ' modal-' + options.size : ''}`} style={{ display: 'none' }}>
            <div className="modal-header">
                <div className="modal-title">{options.title}</div>
                <button className="close" id="close"
                    data-dismiss="modal" aria-label="Close" onClick={closedProc} onMouseEnter={setIsErrMsgDisp(true)} onMouseLeave={setIsErrMsgDisp(false)}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-inner">
                <div>{screenDailog()}</div>
            </div>
            <div className="modal-footer">
                {footerOptions.detailBtn && <button className="btn btn-primary" onClick={footerOptions.detailBtn.func}><span>{isMobile ? '詳細' : '詳細(F9)'}詳細(F9)</span></button>}
                {footerOptions.clearBtn && <button className="btn btn-other" onClick={footerOptions.clearBtn.func}><span>{isMobile ? 'クリア' : 'クリア(F10)'}</span></button>}
                {footerOptions.commitBtn && <button className="btn btn-primary" onClick={footerOptions.commitBtn.func}><span>{isMobile ? '確定' : ' 確定(F12)'}</span></button>}
                <button className="btn btn-other" id="close" onClick={!footerOptions.endBtnFunc ? closedProc : footerOptions.endBtnFunc}>{isMobile ? '終了' : '終了(ESC)'}</button>
            </div>
        </div>
        </></Provider>
    );
})
export default DialogBase;